/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable-next-line array-callback-return */
import RolesForm from "./Form";
import React, { useState, useEffect } from "react";
import { NavLink, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import FormSkeleton from "../../../Components/Skeleton/FormSkeleton";
import ContentWrapper from "../../../Layouts/AdminLTE/ContentWrapper";
import { ShowResourceAction, UpdateResourceAction } from "../../../Redux/Actions/CrudActions";

const RolesEdit = () => {

    const IndexRoute = "/roles"
    const IndexPageName = 'Roles';
    const PageName = 'Edit Role';
    const SubmitButtonName = 'Update Role';
    const BACKEND_ROUTE = "roles";
    const ACTION_TYPE = "COMMON";

    var fields = {
        name: '',
        description: '',
        is_system_role: false,
        permissions: [],
        _method: 'PUT',

    }

    const [data, setData] = useState(fields);

    const [errors, setErrors] = useState(fields);

    const state = useSelector(state => state.common);

    let { id } = useParams();

    const dispatch = useDispatch();

    function show_page_form(edit_id = id) {
        dispatch({ type: `RESTART_${ACTION_TYPE}_FORM` });
        dispatch(ShowResourceAction(BACKEND_ROUTE, edit_id, ACTION_TYPE));
    }
    
    useEffect(() => {
        show_page_form();
    }, []);

    useEffect(() => {

        if (state.form.errors && state.form.errors.validation_errors) {
            const errors = state.form.errors.validation_errors;
            for (let error in errors) {
                var key = error;
                var value = errors[key][0];
                setErrors({ ...errors, [key]: value });
            }
            dispatch({ type: `RESTART_${ACTION_TYPE}_FORM` });
        }

        if (state.form.success && state.form.payload) {
            setErrors(fields);
            setTimeout(() => {
                show_page_form();
            }, 1000);
        }

        if (state.show.success && state.show.payload) {
            setData({
                '_method': 'PUT',
                'name': state.show.payload.data.name ?? '',
                'description': state.show.payload.data.description ?? '',
                'is_system_role': state.show.payload.data.is_system_role ?? '',
                'permissions': state.show.payload.data.permissions ?? '',
            });
            dispatch({ type: `RESTART_${ACTION_TYPE}_SHOW` });
        }
    }, [state]);

    function handleSubmit(e) {
        e.preventDefault();
        dispatch(UpdateResourceAction(BACKEND_ROUTE, id, data, ACTION_TYPE));
    }

    return (
        <ContentWrapper page_name={PageName} breadcrumbs={breadcrumbs(PageName, IndexRoute, IndexPageName)}>
            <div className="card rounded shadow">
                <div className="card-header">
                    <h3 className="card-title">{PageName}</h3>
                </div>
                <div className="card-body">
                    {
                        state.show.loading ?
                            <FormSkeleton />
                            :
                            <RolesForm
                                btnloading={state.form.loading}
                                handleSubmit={handleSubmit}
                                data={data}
                                setData={setData}
                                SubmitButtonName={SubmitButtonName}
                                errors={errors}
                            />
                    }
                </div>
            </div>
        </ContentWrapper>
    );
}

function breadcrumbs(PageName, IndexRoute = false, IndexPageName = false) {
    return (
        <>
            {IndexPageName && <li className="breadcrumb-item"><NavLink to={IndexRoute}>{IndexPageName}</NavLink></li>}
            <li className="breadcrumb-item active">{PageName}</li>
        </>
    )
}

export default RolesEdit;